import React from 'react';
import { Col, Form, Input, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import UIHelper from '../../../../../../../helpers/UIHelper';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';

const InfoSection = ({ companies, inactiveCompanies, asset }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={8}>
        <Form.Item label={t('Asset di riferimento')} name='leasings_asset_id'>
          <Select
            placeholder={t('Leasing manager di riferimento')}
            {...UIHelper.getSelectSearchProps()}
          >
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            {asset.map((company) => (
              <Select.Option key={company.id} value={company.id}>
                {company.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label={t('Stato unità')} name='status'>
          <Select placeholder={t('Stato contatto')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value={'void'}>{t('void')}</Select.Option>
            <Select.Option value={'open'}>{t('open')}</Select.Option>
            <Select.Option value={'in_asset'}>{t('in_asset')}</Select.Option>
          </Select>
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label={t('Insegna')} name='company_id'>
          <Select
            {...Helpers.addSearchProps()}
            placeholder={t('Leasing manager di riferimento')}
          >
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            {renderGroupedShopOptions({
              shops: companies,
              inactiveShops: inactiveCompanies,
              t,
            })}
          </Select>
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item label={t('Note')} name='company_note'>
          <Input.TextArea placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label={t('Unità')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label={t('Impianto a/c')} name='plant_ac'>
          <Select placeholder={t('Stato contatto')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value={'present'}>{t('Presente')}</Select.Option>
            <Select.Option value={'absent'}>{t('Assente')}</Select.Option>
          </Select>
        </Form.Item>
      </Col>
      {/* <Col span={8}>
        <Form.Item label={t('Note')} name='plant_ac_note'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col> */}

      <Col span={8}>
        <Form.Item label={t('GLA')} name='gla'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label={t('Impianto luci')} name='plant_lights'>
          <Select placeholder={t('Stato contatto')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value={'present'}>{t('Presente')}</Select.Option>
            <Select.Option value={'absent'}>{t('Assente')}</Select.Option>
          </Select>
        </Form.Item>
      </Col>
      {/* <Col span={8}>
        <Form.Item label={t('Note')} name='plant_lights_note'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col> */}

      <Col span={8}>
        <Form.Item label={t('Quota minima stock')} name='sales_area'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label={t('Antitaccheggio')} name='plant_anti_theft'>
          <Select placeholder={t('Stato contatto')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value={'present'}>{t('Presente')}</Select.Option>
            <Select.Option value={'absent'}>{t('Assente')}</Select.Option>
          </Select>
        </Form.Item>
      </Col>
      {/* <Col span={8}>
        <Form.Item label={t('Note')} name='plant_anti_theft_note'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col> */}

      <Col span={8}>
        <Form.Item label={t('Finitura')} name='finish'>
          <Select placeholder={t('Stato contatto')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value={'rustic'}>{t('Rustico')}</Select.Option>
            <Select.Option value={'fake'}>{t('Finita')}</Select.Option>
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label={t('Arredo')} name='furniture'>
          <Select placeholder={t('Stato contatto')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value={'present'}>{t('Presente')}</Select.Option>
            <Select.Option value={'absent'}>{t('Assente')}</Select.Option>
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label={t('Note')} name='furniture_note'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label={t('Bagno')} name='wc'>
          <Select placeholder={t('Stato contatto')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value={'present'}>{t('Presente')}</Select.Option>
            <Select.Option value={'absent'}>{t('Assente')}</Select.Option>
          </Select>
        </Form.Item>
      </Col>
      {/* <Col span={8}>
        <Form.Item label={t('Note')} name='wc_note'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col> */}
    </Row>
  );
};

export default React.memo(InfoSection);
